<!-- <p>login-options works!</p> -->
<section class="" id="login-signUp">
    <div class="container">
        <div class="row mx-2 justify-content-between heading-section" style="display: flex;">
            <h2 class="mb-1 egd-heading text-black"><span>Login/Register</span></h2>
            <div style="display: flex;align-items: first baseline;margin-top: 10px;">
                <div style="font-size: 17px;font-weight: bold;">
                    <p>Choose Language : </p>
                </div>
                <select class="notranslate customize-dropdown" [(ngModel)]="selectedLanguage"
                    (change)="translatePage($event)">
                    <option *ngFor="let option of languageOptions" [value]="option.code">
                        {{ option.name }}
                    </option>
                </select>
            </div>
            <!-- <div id="google_translate_element" style="display: none;"></div> -->
        </div>
        <div class="container-fluid">
            <div class="row my-5">

                <div class="col-sm-12 col-md-6 col-lg-4 my-3">
                    <div class="card three-d-card h-100">
                        <div class="card-body">
                            <div class="card three-d-card w-30 img-top">
                                <img src="./assets/images/LoginScreenCards/Health_provider_patient.png"
                                    class="card-img-top" alt="...">
                            </div>
                            <h5 class="card-title mt-3 pb-3 login-card-heading">
                                For Patients
                            </h5>
                            <div class="card-text login-card-text-height">
                                <div class="row">
                                    <div class="col-sm-12 overflow-auto mb-3" style="max-height: 150px;">
                                        Take your healthcare to the next level. Take it into your hands. You
                                        choose the care you need
                                        from a select group of
                                        physicians from the convenience of your home.
                                    </div>
                                    <div
                                        class="col-sm-12 text-center position-absolute login-card-button-section mt-3 d-flex justify-content-center pl-0 setBtnsUI">

                                        <button type="button" [routerLink]="['/', this.slug, 'user', 'login', 'patient']"
                                            class="btn btn-default btn-primary egd-theme-white-bg-btn egd-login-signup-buttons mx-2"
                                            role="button">
                                            <span class="egd-theme-white-bg-btn-label ">
                                                Login
                                            </span>
                                        </button>

                                        <button type="button" [routerLink]="['/', this.slug, 'user', 'register', 'patient']"
                                            class="btn btn-default btn-primary white-theme-egd-bg-btn egd-login-signup-buttons mx-2"
                                            role="button">
                                            <span class="white-theme-egd-bg-btn-label ">
                                                Register
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-12 col-md-6 col-lg-4 my-3">
                    <div class="card three-d-card h-100">
                        <div class="card-body">
                            <div class="card three-d-card w-30 img-top">
                                <img src="./assets/images/LoginScreenCards/Health_care_provider_doctor.png"
                                    class="card-img-top" alt="...">
                            </div>
                            <h5 class="card-title mt-3 pb-3 login-card-heading">
                                For Doctors
                            </h5>
                            <div class="card-text login-card-text-height">
                                <div class="row">
                                    <div class="col-sm-12 overflow-auto mb-3" style="max-height: 150px;">
                                        Elevate your healthcare delivery- provide care to patients
                                        efficiently. Improve your patient
                                        base and access.
                                    </div>
                                    <div
                                        class="col-sm-12 text-center position-absolute login-card-button-section mt-3 d-flex justify-content-center pl-0 setBtnsUI" >
                                        <button type="button"
                                        [routerLink]="['/', this.slug, 'user', 'login', 'health-care-professionals', userTypes['DOCTOR']]"
                                            class="btn btn-default btn-primary egd-theme-white-bg-btn egd-login-signup-buttons mx-2"
                                            role="button">
                                            <span class="egd-theme-white-bg-btn-label ">
                                                Login
                                            </span>
                                        </button>

                                        <button type="button" (click)="open_doctor_refferal()"
                                            class="btn btn-default btn-primary white-theme-egd-bg-btn egd-login-signup-buttons mx-2"
                                            role="button" *ngIf="this.isPrimaryProvider">
                                            <span class="white-theme-egd-bg-btn-label ">
                                                Register
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 offset-md-3 col-md-6 offset-lg-0 col-lg-4 my-3" *ngIf="this.isPrimaryProvider && !this.is_uk_country"> 
                    <div class="card three-d-card h-100">
                        <div class="card-body">
                            <div class="card three-d-card w-30 img-top">
                                <img src="./assets/images/LoginScreenCards/Health_provider_health_care_provider.png"
                                    class="card-img-top" alt="...">
                            </div>
                            <h5 class="card-title mt-3 pb-3 login-card-heading">
                                Other Healthcare Providers
                            </h5>
                            <div class="card-text login-card-text-height">
                                <div class="row">
                                    <div class="col-sm-12 overflow-auto mb-3" style="max-height: 150px;">
                                        Expand your reach. Provide your services to patients without
                                        barriers.[Nutritionist, Nurse Practitioner, Physiotherapist]
                                    </div>
                                    <div
                                        class="col-sm-12 text-center position-absolute login-card-button-section mt-3 d-flex justify-content-center pl-0 setBtnsUI">
                                        <button type="button"
                                        [routerLink]="['/', this.slug, 'user', 'login', 'health-care-professionals', this.userTypes['OTHER-MEDICAL-PROFESSIONALS']]"
                                            class="btn btn-default btn-primary egd-theme-white-bg-btn egd-login-signup-buttons mx-2"
                                            role="button">
                                            <span class="egd-theme-white-bg-btn-label ">
                                                Login
                                            </span>
                                        </button>

                                        <button type="button" (click)="open_otherMedicalProf_refferal()"
                                            class="btn btn-default btn-primary white-theme-egd-bg-btn egd-login-signup-buttons mx-2"
                                            role="button">
                                            <span class="white-theme-egd-bg-btn-label ">
                                                Register
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>